import {
  requestFiles,
  cancelRequest,
  deleteFiles,
  downloadSupportFileConstants,
} from "../_redux-constants";

export function supportFilesReducer(
  state = {
    // Request support files
    requestFilesLoading: false,
    requestFilesData: null,
    requestFilesError: null,

    // Cancel support files request
    cancelRequestLoading: false,
    cancelRequestData: null,
    cancelRequestError: null,

    // Delete support files request
    deleteFilesLoading: false,
    deleteFilesData: null,
    deleteFilesError: null,

    downloadSupportFileLoading: false,
    downloadSupportFileData: null,
    downloadSupportFileError: null,
  },
  action
) {
  switch (action.type) {
    // Request support files
    case requestFiles.FILE_REQUEST_LOADING:
      return Object.assign({}, state, {
        requestFilesLoading: true,
        requestFilesData: null,
        requestFilesError: null,
      });
    case requestFiles.FILE_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        requestFilesLoading: false,
        requestFilesData: action.data,
      });
    case requestFiles.FILE_REQUEST_FAILURE:
      return Object.assign({}, state, {
        requestFilesLoading: false,
        requestFilesData: null,
        requestFilesError: action.error,
      });

    // Cancel support files request
    case cancelRequest.CANCEL_REQUEST_LOADING:
      return Object.assign({}, state, {
        cancelRequestLoading: true,
        cancelRequestData: null,
        cancelRequestError: null,
      });
    case cancelRequest.CANCEL_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        cancelRequestLoading: false,
        cancelRequestData: action.data,
      });
    case cancelRequest.CANCEL_REQUEST_FAILURE:
      return Object.assign({}, state, {
        cancelRequestLoading: false,
        cancelRequestData: null,
        cancelRequestError: action.error,
      });

    // Delete support files request
    case deleteFiles.DELETE_FILES_LOADING:
      return Object.assign({}, state, {
        deleteFilesLoading: true,
        deleteFilesData: null,
        deleteFilesError: null,
      });
    case deleteFiles.DELETE_FILES_SUCCESS:
      return Object.assign({}, state, {
        deleteFilesLoading: false,
        deleteFilesData: action.data,
      });
    case deleteFiles.DELETE_FILES_FAILURE:
      return Object.assign({}, state, {
        deleteFilesLoading: false,
        deleteFilesData: null,
        deleteFilesError: action.error,
      });
    case downloadSupportFileConstants.DWNLD_VERSION_FILE_LOADING:
      return Object.assign({}, state, {
        downloadSupportFileLoading: true,
        downloadVersionFileData: null,
        downloadVersionFileError: null,
      });
    case downloadSupportFileConstants.DWNLD_VERSION_FILE_SUCCESS:
      return Object.assign({}, state, {
        downloadSupportFileLoading: false,
        downloadSupportFileData: action.data,
      });
    case downloadSupportFileConstants.DWNLD_VERSION_FILE_FAILURE:
      return Object.assign({}, state, {
        downloadSupportFileLoading: false,
        downloadSupportFileData: null,
        downloadSupportFileError: action.error,
      });

    default:
      return state;
  }
}
